import { ADD_BUNDLE_ITEM, REMOVE_BUNDLE_ITEM, UPDATE_BUNDLE_ITEM } from "./types"
import { BundleItem } from "../models/BundleItem"

export function bundleAddItem(payload: BundleItem) {
    return {
        type: ADD_BUNDLE_ITEM,
        payload: payload
    }
}

export function bundleRemoveItem(payload: BundleItem) {
    return {
        type: REMOVE_BUNDLE_ITEM,
        payload: payload
    }
}

export function bundleUpdateItem(payload: BundleItem[]) {
    return {
        type: UPDATE_BUNDLE_ITEM,
        payload: payload
    }
}


// WEBPACK FOOTER //
// ./src/state/product/bundle/actions/actions.ts